export const philippineCities = [
  'Manila',
  'Quezon City',
  'Makati',
  'Pasig',
  'Taguig',
  'Pasay',
  'Marikina',
  'Muntinlupa',
  'Las Piñas',
  'Parañaque',
  'Valenzuela',
  'Malabon',
  'Navotas',
  'San Juan',
  'Mandaluyong',
  'Pateros',
  'Cebu City',
  'Davao City',
  'Zamboanga City',
  'Antipolo',
  'Cagayan de Oro',
  'Bacolod',
  'General Santos',
  'Iloilo City',
  'Butuan',
  'Iligan',
  'Cotabato City',
  'Tacloban',
  'Dagupan',
  'Naga',
  'Ormoc',
  'Santiago',
  'Tuguegarao',
  'Tabuk',
  'Malaybalay',
  'Cabanatuan',
  'Olongapo',
  'Angeles',
  'Tarlac City',
  'Malolos',
  'Meycauayan',
  'San Jose del Monte',
  'Bacoor',
  'Imus',
  'Dasmariñas',
  'Calamba',
  'Santa Rosa',
  'Biñan',
  'San Pedro',
  'Cabuyao',
  'San Pablo',
  'Lucena',
  'Lipa',
  'Tanauan',
  'Batangas City',
  'Calapan',
  'Puerto Princesa',
  'Tagbilaran',
  'Dumaguete',
  'Bago',
  'Kabankalan',
  'Sipalay',
  'Roxas',
  'Kalibo',
  'Boracay',
  'Legazpi',
  'Sorsogon City',
  'Masbate City',
  'Catbalogan',
  'Calbayog',
  'Maasin',
  'Baybay',
  'Surigao City',
  'Bislig',
  'Tandag',
  'Bayugan',
  'Cabadbaran',
  'Gingoog',
  'Oroquieta',
  'Ozamiz',
  'Tangub',
  'Dapitan',
  'Dipolog',
  'Pagadian',
  'Koronadal',
  'Kidapawan',
  'Marbel',
  'Tacurong',
  'Isulan',
  'Malita',
  'Digos',
  'Panabo',
  'Samal',
  'Tagum',
  'Mati',
  'Baguio',
  'La Trinidad',
  'Tabuk',
  'Bangued',
  'Vigan',
  'Laoag',
  'Batac'
];